import { create } from 'zustand'
import { ILightRailItem, IShortVideoItem } from '../../types'

interface IOttStore {
  searchQuery: string
  setSearchQuery: (newQuery: string) => void

  episodeDescription: string | null
  setEpisodeDescription: (episodeDescription: string) => void

  additionalEpisodes: ILightRailItem[] | null
  setAdditionalEpisodes: (additionalEpisodes: ILightRailItem[] | null) => void

  shortVideos: IShortVideoItem[] | null
  setShortVideos: (shortVideos: IShortVideoItem[] | null) => void
}

export const useOttStore = create<IOttStore>()(set => ({
  searchQuery: '',
  setSearchQuery: newQuery => set({ searchQuery: newQuery }),

  episodeDescription: null,
  setEpisodeDescription: (episodeDescription: string | null) =>
    set({ episodeDescription }),

  additionalEpisodes: null,
  setAdditionalEpisodes: (additionalEpisodes: ILightRailItem[] | null) =>
    set({ additionalEpisodes }),

  shortVideos: null,
  setShortVideos: (shortVideos: IShortVideoItem[] | null) =>
    set({ shortVideos }),
}))
